import React, { Component } from 'react';
import Breadcrumbs, { textResolver } from 'react-router-breadcrumbs';
import { Link } from 'react-router';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Footer } from '../common';
import LeftNav from './publisher/LeftNav';
import TopNav from './publisher/TopNav';
import { layoutHelper } from '../layouts';
import { titleize } from '../../utils/helpers/text_formatters';

class Publisher extends Component {
  componentDidMount() {
    layoutHelper();
  }

  hasSideNav() {
    const { location: { pathname }, website } = this.props;

    return pathname.match(/publisher\/home\/websites\/(.*)/) !== null && Object.keys(website).length > 0;
  }

  render() {
    const {
      website,
      routes,
      params,
      location,
    } = this.props;

    const pathname = get(location, 'pathname');

    const CustomLink = (link, key, text, index, routers) => {
      const isLastElement = index === routers.length - 1;
      const cls = isLastElement ? '' : 'active';
      return (
        <li key={key}>
          <Link to={link} className={cls}>{titleize(text)}</Link>
        </li>
      );
    };

    return (
      <div id='wrapper'>
        {this.hasSideNav() && <LeftNav pathname={pathname} website={website} />}
        <div id={this.hasSideNav() ? 'page-wrapper' : 'page-wrapper-main'} className='gray-bg'>
          <TopNav sideBtn website={website} />
          <div className={`wrapper wrapper-content${this.hasSideNav() ? '' : ' m-t-xxl'}`}>
            <div className="container-fluid">
              <div className='m-b-md'>
                <Breadcrumbs
                  resolver={textResolver}
                  routes={routes}
                  wrappingComponent={'ol'}
                  className={'breadcrumb'}
                  createLink={CustomLink}
                  params={params}
                  createSeparator=''
                />
              </div>
              {this.props.children}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user, publisher: { websites } } = state;
  const { children: { props: { params } } } = ownProps;
  const { websiteName } = params;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};

  return {
    user: user.data,
    websites: websites.data,
    website,
    params
  };
};

export default connect(mapStateToProps)(Publisher);
